module.exports = __webpack_public_path__ + "assets/img/wwg.a708f762.png";